import { createContext } from "react";

interface DashboardContextType {
  assets: any;
  liabilities: any;
  selectedAccount: any;
  transactions: any;
  assetsTotal: any;
  liabilitiesTotal: any;
  netWorth: any;
  portfolioList: any;
  setSelectedAccount: any;
  selectedPortfolio: any;
  setSelectedPortfolio: any;
  fxRates: any;
  availableCash: any;
  sumOfPendingCash: any;
  pendingDepositCash: any;
  pendingRedemptionCash: any;
  pendingWithdrawCash: any;
  pendingSubscriptionRequests: any;
  loading: any;
  totalPayableCash: any;
  selectedAccountTotalAssets: any;
  selectedAccountTotalLiabilities: any;
  selectedAccountNetWorth: any;
  pendingSubscriptionCash: any;
  setLoading: any;
}

// Create the Global Context
const DashboardContext = createContext<DashboardContextType | undefined>(
  undefined
);

export default DashboardContext;
